export enum Types {
	GERAR_RENACH_PRIMEIRA_HABILITACAO = '@cnh/GERAR_RENACH_PRIMEIRA_HABILITACAO',
	GERAR_RENACH_PRIMEIRA_HABILITACAO_SUCCESS = '@cnh/GERAR_RENACH_PRIMEIRA_HABILITACAO_SUCCESS',
	GERAR_RENACH_PRIMEIRA_HABILITACAO_FAILURE = '@cnh/GERAR_RENACH_PRIMEIRA_HABILITACAO_FAILURE',
}

export interface gerarRenachPrimeiraHabilitacao {
	status: number;
	data: null;
}
export interface IRequestGerarRenachPrimeiraHabilitacao {
	autorizaEmail: string;
	autorizaSMS: string;
	bairro: string;
	categoriaAtual: string;
	categoriaPretendida: string;
	telefone: string;
	celular: string;
	cep: string;
	cnhDigital: string;
	codigoEntidade: string;
	codigoVerificador: string;
	complemento: string;
	cpf: string;
	dataNascimento: string;
	dataPrimeiraHabilitacao: string;
	dddCelular: string;
	dddTelefone: string;
	email: string;
	logradouro: string;
	nacionalidade: string;
	naturalidade: string;
	necessidadeVeiculoAdaptado: string;
	nome: string;
	nomeMae: string;
	nomePai: string;
	numCarteiraMilitar: string;
	numDocumento: string;
	numPGU: string;
	numRNE: string;
	numRegistro: string;
	numero: string;
	orgaoDocumento: string;
	orgaoRNE: string;
	pretendeAtividadeRemunerada: string;
	sexo: string;
	tipoDocumento: string;
	ufDocumento: string;
	ufRNE: string;
}
